<div *ngIf="showBanner()" class="fixed bottom-0 left-0 right-0 z-50 bg-gradient-to-r from-immovea-navy via-blue-900 to-blue-950 text-white shadow-2xl border-t border-blue-700 animate-slide-up">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
    <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
      <!-- Message -->
      <div class="flex-1">
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 mt-0.5">
            <svg class="w-6 h-6 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
          <div>
            <h3 class="text-base sm:text-lg font-bold mb-1">Cookie Notice</h3>
            <p class="text-sm sm:text-base text-blue-200 leading-relaxed">
              This website uses cookies to enhance your browsing experience.
              By clicking "Accept", you consent to our use of cookies.
            </p>
          </div>
        </div>
      </div>

      <!-- Buttons -->
      <div class="flex gap-3 w-full sm:w-auto">
        <button
          (click)="rejectCookies()"
          class="flex-1 sm:flex-none px-6 py-2.5 bg-blue-800 hover:bg-blue-700 text-white font-semibold rounded-lg transition-all border border-blue-700 hover:border-blue-600"
        >
          Decline
        </button>
        <button
          (click)="acceptCookies()"
          class="flex-1 sm:flex-none px-6 py-2.5 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-bold rounded-lg transition-all shadow-lg hover:shadow-xl transform hover:scale-105"
        >
          Accept
        </button>
      </div>
    </div>
  </div>
</div>
